import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import storeService from '../../services/storeService';

const OrderingSettings = () => {
  const [settings, setSettings] = useState({
    onlineOrderNotes: 'Optional',
    paidOrderAcceptance: 'Manually',
  });
  const [isLoading, setIsLoading] = useState(true);
  const [success, setSuccess] = useState('');
  const { id: storeId } = useParams();

  const fetchStoreData = useCallback(async () => {
    try {
      const data = await storeService.getStoreById(storeId);
      if (data.orderingSettings) {
        setSettings(data.orderingSettings);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }, [storeId]);

  useEffect(() => {
    fetchStoreData();
  }, [fetchStoreData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    await storeService.updateStore(storeId, { orderingSettings: settings });
    setSuccess('Ordering settings saved successfully!');
    setTimeout(() => setSuccess(''), 3000);
  };

  if (isLoading) return <div>Loading ordering settings...</div>;

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Ordering Settings</h2>
      {success && <p className="bg-green-100 text-green-700 p-3 rounded mb-4">{success}</p>}
      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700">Online Order Notes</label>
          <div className="mt-2 flex space-x-4">
            <label><input type="radio" name="onlineOrderNotes" value="Optional" checked={settings.onlineOrderNotes === 'Optional'} onChange={handleChange} className="mr-1" /> Optional</label>
            <label><input type="radio" name="onlineOrderNotes" value="Disabled" checked={settings.onlineOrderNotes === 'Disabled'} onChange={handleChange} className="mr-1" /> Disabled</label>
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Online Paid Order Acceptance</label>
          <div className="mt-2 flex space-x-4">
            <label><input type="radio" name="paidOrderAcceptance" value="Manually" checked={settings.paidOrderAcceptance === 'Manually'} onChange={handleChange} className="mr-1" /> Manually</label>
            <label><input type="radio" name="paidOrderAcceptance" value="Automatically" checked={settings.paidOrderAcceptance === 'Automatically'} onChange={handleChange} className="mr-1" /> Automatically</label>
          </div>
        </div>
        {/* Add other ordering settings from your screenshots here */}
      </div>
      <div className="flex justify-end mt-6">
        <button onClick={handleSave} className="bg-primary text-white px-6 py-2 rounded-md">Save Settings</button>
      </div>
    </div>
  );
};

export default OrderingSettings;